<!-- Header above table -->
<div class="w-100 mb-1 table-top-container clearfix">
    <div class="top-left-container form-inline">
        <div
            id="notMobile"
            class="btn-container"
        >
            <pcg-button-hide-show
                class="hidden-sm"
                [columnDefs]="columnDefs"
            ></pcg-button-hide-show>

            @if (filterId) {
                <pcg-button-filter
                    id="pcg-button-filter"
                    class="ml-2 hidden-sm"
                    [filterId]="filterId"
                ></pcg-button-filter>
            }

            @if (showResetFilterBtn()) {
                <pcg-button-reset-filter
                    class="ml-2 hidden-sm mr-2"
                ></pcg-button-reset-filter>
            }
        </div>
    </div>

    <div
        id="isMobile"
        class="btn-container hidden-md-plus"
        style="margin-top: 0; margin-bottom: 0"
    >
        <pcg-button-hide-show [columnDefs]="columnDefs"></pcg-button-hide-show>
        @if (filterId) {
            <pcg-button-filter
                id="pcg-button-filter"
                [filterId]="filterId"
                class="ml-2"
            ></pcg-button-filter>
        }
        @if (showResetFilterBtn()) {
            <pcg-button-reset-filter class="ml-2"></pcg-button-reset-filter>
        }
    </div>

    <!-- Applied filters -->
    @if (filterMap && btnFilterService.getActiveFilters(ajaxData, filterMap)) {
        <div>
            <div
                class="applied-filters top-left-container form-inline alert-success d-flex flex-row align-items-start form-control-sm"
                role="alert"
            >
                Applied Filters:
                {{ btnFilterService.getActiveFilters(ajaxData, filterMap) }}
            </div>
        </div>
    }

    <div class="top-right-container">
        <!-- Search -->
        @if (canGlobalSearch) {
            <div class="search-container form-inline">
                <div>
                    <input
                        type="search"
                        class="form-control btn-outline"
                        placeholder="Search..."
                        (input)="filterSource.next($event.target.value)"
                        (click)="clearSearch($event)"
                    />
                </div>
            </div>
        }

        <!-- column tooltip modal -->
        <ng-template
            #tooltipModal
            let-modal
        >
            <div class="modal-header">
                <h5>Column Tooltips</h5>
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    (click)="modal.dismiss()"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body flex-body">
                <pcg-table-top-tooltip
                    [innerHTML]="tooltipContent"
                ></pcg-table-top-tooltip>
            </div>
        </ng-template>

        <!-- Export actions -->
        <div class="inline-page-actions">
            <div id="pageActions">
                @if (hasTooltips && isMobile) {
                    <button
                        ngbTooltip="Column Tooltips"
                        (click)="tooltipButtonClicked()"
                        class="new-page-action"
                    >
                        <fa-icon [icon]="faIconName.faQuestion"></fa-icon>
                    </button>
                }

                @if (canExportTableToExcel || excelUrl) {
                    <button
                        ngbTooltip="Export to Excel"
                        (click)="getExcel()"
                        class="new-page-action"
                    >
                        <img src="assets/images/actions/xlsxgreen.svg" />
                    </button>
                }

                <!-- Print button -->
                @if (canPrintTable) {
                    <button
                        ngbTooltip="Print the Report"
                        (click)="table.print()"
                        class="new-page-action"
                    >
                        <fa-icon
                            [icon]="faIconName.faPrint"
                            class="table-action-icon fa-lg"
                            style="color: #2980b9"
                        ></fa-icon>
                    </button>
                }
            </div>
        </div>
    </div>
</div>
